import {createContext} from 'react';

const UploadSettings = createContext({batchName:"", numRows:0, numCols:0, isDisabled:false, updateUploadSettings:()=>{}});

export default UploadSettings;